export const blockIconsHouseholdWindowNew = (
	<span className='material-symbols-outlined'>window</span>
);
